import React from 'react';
import { noop } from 'lodash';
import classnames from 'classnames';
import { useBreakpoints } from '@fiverr-private/hooks';
import { PaperPlaneIcon, SpinnerAnimatedIcon } from '@fiverr-private/icons';
import { white } from '@fiverr-private/sass/helpers';
import { I18n } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/button';
import { Stack } from '@fiverr-private/layout_components';
import { useMonitoring } from '../../../utils/monitoring/useMonitoring';
import styles from './index.module.scss';

const T_PREFIX = 'seller_pages_toolbox.pro_contact';

interface ContactButtonDisplayComponentProps extends Partial<React.ComponentProps<typeof Button>> {
    isLoading?: boolean;
    source: string;
    componentName: string;
    onClick: () => void;
    buttonCopy: React.ReactNode;
    withGradient: boolean;
}

export const ContactButtonDisplayComponent = ({
    isLoading,
    source,
    componentName,
    onClick = noop,
    buttonCopy,
    withGradient = false,
    ...buttonProps
}: ContactButtonDisplayComponentProps) => {
    const { sm: isSM } = useBreakpoints();
    const { fireEvents, Providers } = useMonitoring();
    const handleClick = () => {
        onClick();
        fireEvents({
            [Providers.BigQuery]: {
                type: 'business_seller_page.contact_me',
                event_source: source,
                component_name: componentName,
            },
        });
        fireEvents({
            [Providers.Mixpanel]: {
                type: 'clicked contact me',
                source,
                component_name: componentName,
            },
        });
    };

    const buttonCopyIcon = !buttonCopy && <PaperPlaneIcon color={white} />;

    return (
        <Button
            {...buttonProps}
            onClick={handleClick}
            fullWidth
            className={classnames({ [styles.buttonWithGradient]: withGradient })}
        >
            <Stack alignItems="center" justifyContent="center" gap="2">
                {isLoading ? <SpinnerAnimatedIcon color={white} /> : buttonCopyIcon}
                {buttonCopy || <I18n k={isSM ? `${T_PREFIX}.button` : `${T_PREFIX}.contact`} />}
            </Stack>
        </Button>
    );
};
